<template>
  <div class="main-simule-aqui">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="simule-aqui">
            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-page="true"
              class="overlay-load"
              :z-index="9999"
            >
            </loading>

            <transition name="fade" mode="out-in">
              <StepUm v-if="etapa === 'step-1'" 
              />
              <StepDois
                v-else-if="etapa === 'step-2'"
              />
              <StepTres
                v-else-if="etapa === 'step-3'"
              />
              <StepTresAlt
                v-else-if="etapa === 'step-3-alt'"
              />
              <StepQuatro
                v-else-if="etapa === 'step-4'"
              />
              <StepCinco
                v-else-if="etapa === 'step-5'"
              />
            </transition>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import buscarEntidadeOrgaoUF from "@/services/buscarEntidadeOrgaoUf";
import buscarEnderecoAPI from "@/services/buscarEnderecoAPI";
import buscarEstadoIDAPI from "@/services/buscarEstadoID.js";
import buscarConveniosAPI from "@/services/buscarConvenios";
import buscarEntidadeOrgaoAPI from "../services/buscarEntidadeOrgaoAPI";
import buscarEntidadesAPI from "@/services/buscarEntidadesAPI";
import buscarProfissoesAPIWP from "@/services/buscarProfissoes";
import listarGrauParentesco from "@/services/listarGrauDependentes";
import integracaoQLCEcommerce from "@/services/integracaoQLCEcommerce";
import StepUm from "@/views/steps/StepUm";
import StepDois from "@/views/steps/StepDois";
import StepTres from "@/views/steps/StepTres";
import StepTresAlt from "@/views/steps/StepTresAlt";
import StepQuatro from "@/views/steps/StepQuatro";
import StepCinco from "@/views/steps/StepCinco";
import Loading from "vue-loading-overlay";
import VueMask from "v-mask";
import store from "@/store";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
Vue.use(VueMask);

export default {
  name: "Simule-aqui",
  mixins: [],
  components: {
    Loading,
    StepUm,
    StepDois,
    StepTres,
    StepTresAlt,
    StepQuatro,
    StepCinco,
  },
  data() {
    return {
      preenchido: false,
      errors: [],
    };
  },
  computed: {
    emailValid() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    etapa: {
      get() {
        return store.getters.getAliancaProxEtapa;
      },
      set(newVal) {
        store.commit("mutAliancaProxEtapa", newVal);
      },
    },
    estadoid: {
      get() {
        return store.getters.getAliancaEstadoID;
      },
      set(newVal) {
        store.commit("mutAliancaEstadoID", newVal);
      },
    },
    cep: {
      get() {
        return store.getters.getSimuleAquiCep;
      },
      set(newVal) {
        store.commit("mutSimuleAquiCep", newVal);
      },
    },
    nome: {
      get() {
        return store.getters.getSimuleAquiNome;
      },
      set(newVal) {
        store.commit("mutSimuleAquiNome", newVal);
      },
    },
    datanasc: {
      get() {
        return store.getters.getSimuleAquiDataNasc;
      },
      set(newVal) {
        store.commit("mutSimuleAquiDataNasc", newVal);
      },
    },
    email: {
      get() {
        return store.getters.getSimuleAquiEmail;
      },
      set(newVal) {
        store.commit("mutSimuleAquiEmail", newVal);
      },
    },
    telefone: {
      get() {
        return store.getters.getSimuleAquiTelefone;
      },
      set(newVal) {
        store.commit("mutSimuleAquiTelefone", newVal);
      },
    },
    estadoapi: {
      get() {
        return store.getters.getSimuleAquiEstadoApi;
      },
      set(newVal) {
        store.commit("mutSimuleAquiEstadoApi", newVal);
      },
    },
    selected_entidade: {
      get() {
        return store.getters.getSimuleAquiSelectedEntidade;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedEntidade", newVal);
      },
    },
    selected_orgao: {
      get() {
        return store.getters.getSimuleAquiSelectedOrgao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedOrgao", newVal);
      },
    },
    selected_profissao: {
      get() {
        return store.getters.getSimuleAquiSelectedProfissao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedProfissao", newVal);
      },
    },
    options_entidades: {
      get() {
        return store.getters.getSimuleAquiEntidades;
      },
      set(newVal) {
        store.commit("mutSimuleAquiEntidades", newVal);
      },
    },
    estadoEndUf(){
      return store.getters.getAliancaEndUF;
    },
    resBuscaOrgEnt(){
      return buscarEntidadeOrgaoUF(this.estadoEndUf)
    },
    options_orgaos: {
      get() {
        return store.getters.getSimuleAquiOrgaos;
      },
      set(newVal) {
        store.commit("mutSimuleAquiOrgaos", newVal);
      },
    },
    options_profissoes: {
      get() {
        return store.getters.getSimuleAquiProfissoes;
      },
      set(newVal) {
        store.commit("mutSimuleAquiProfissoes", newVal);
      },
    },
    isLoading: {
      get() {
        return store.getters.getSimuleAquiLoader;
      },
      set(newVal) {
        store.commit("mutSimuleAquiLoader", newVal);
      },
    },
    tipoorgaoentidade: {
      get() {
        return store.getters.getSimuleAquiTipoOrgaoEntidade;
      },
      set(newVal) {
        store.commit("mutSimuleAquiTipoOrgaoEntidade", newVal);
      },
    },
    validaCEP: {
      get() {
        return store.getters.getSimuleAquiValidaCep;
      },
      set(newVal) {
        store.commit("mutSimuleAquiValidaCep", newVal);
      },
    },
    resetModeStep: {
      get() {
        return store.getters.getSimuleAquiResetMode;
      },
      set(newVal) {
        store.commit("mutSimuleAquiResetMode", newVal);
      },
    },
    consentimentolgpd: {
      get() {
        return store.getters.getSimuleAquiConsentimentoLgpd;
      },
      set(newVal) {
        store.commit("mutSimuleAquiConsentimentoLgpd", newVal);
      },
    },
    finalizaprocesso: {
      get() {
        return store.getters.getSimuleAquiFinalizaProcesso;
      },
      set(newVal) {
        store.commit("mutSimuleAquiFinalizaProcesso", newVal);
      },
    },
    exibefinaliza: {
      get() {
        return store.getters.getSimuleAquiExibeFinaliza;
      },
      set(newVal) {
        store.commit("mutSimuleAquiExibeFinaliza", newVal);
      },
    },
    options_grauparentesco: {
      get() {
        return store.getters.getSimuleAquiGrauParentesco;
      },
      set(newVal) {
        store.commit("mutSimuleAquiGrauParentesco", newVal);
      },
    },
    selected_faixa: {
      get() {
        return store.getters.getSimuleAquiSelectedFaixa;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedFaixa", newVal);
      },
    },
    options_faixaremuneracao: {
      get() {
        return store.getters.getSimuleAquiFaixaRemuneracao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiFaixaRemuneracao", newVal);
      },
    },
    preenchidoprofissoes: {
      get() {
        return store.getters.getSimuleAquiPreenchidoProfissoes;
      },
      set(newVal) {
        store.commit("mutSimuleAquiPreenchidoProfissoes", newVal);
      },
    },
    traducaodatepicker: {
      get() {
        return store.getters.getSimuleAquiTraducaoDatePicker;
      },
      set(newVal) {
        store.commit("mutSimuleAquiTraducaoDatePicker", newVal);
      },
    },
  },
  methods: {
    // Deveria estar no componente stepDois, mas tive alguns problemas com emit
    semDependentes() {
      this.dependentes = [];

      this.incluirDependente = false;
      this.finalizaprocesso = true;
      this.exibefinaliza = true;

      this.setEtapa("step-4", "step-5", "NPD");
    },
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, "");
      str = str.toLowerCase();

      let from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      let to = "aaaaaaeeeeiiiioooouuuunc------";

      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");

      return str;
    },
    async buscarEndereco(cep) {
      if (cep == "01313020") {
        this.getEstadoSigla("SP");
        store.commit("mutAliancaCEP", cep);
        store.commit("mutAliancaCodEnd", null);
        store.commit("mutAliancaEndBairro", "BELA VISTA");
        store.commit("mutAliancaEndCidade", "SÃO PAULO");
        store.commit("mutAliancaEndComp", "");
        store.commit("mutAliancaEndRua", "RUA DOUTOR PLÍNIO BARRETO");
        store.commit("mutAliancaEndGia", "");
        store.commit("mutAliancaEndIbge", "");
        store.commit("mutAliancaEndTipo", "");
        store.commit("mutAliancaEndUF", "SP");

        return false;
      }

      var endereco = await buscarEnderecoAPI({
        uf: "",
        cep: cep,
        bairro: "",
        cidade: "",
        endereco_benef: "",
      });

      if (!endereco[0]) {
        this.$bvToast.toast("CEP não encontrado", {
          variant: "danger",
          solid: true,
        });

        return false;
      }

      await this.getEstadoSigla(endereco[0].UF);
      store.commit("mutAliancaCEP", endereco[0].CEP);
      store.commit("mutAliancaCodEnd", endereco[0].CODMUN);
      store.commit("mutAliancaEndBairro", endereco[0].BAIRRO);
      store.commit("mutAliancaEndCidade", endereco[0].CIDADE);
      store.commit("mutAliancaEndComp", "");
      store.commit("mutAliancaEndRua", endereco[0].ENDERECO_BENEF);
      store.commit("mutAliancaEndGia", "");
      store.commit("mutAliancaEndIbge", "");
      store.commit("mutAliancaEndTipo", "");
      store.commit("mutAliancaEndUF", endereco[0].UF);

      this.getBuscaOrgEnd();
      return true;
    },
    async getBuscaOrgEnd(){
      this.isLoading = true;
      console.log('estadoEndUf', this.estadoEndUf)
      this.listaOrgEnt = await this.resBuscaOrgEnt;
      let listarEntOrg = this.listaOrgEnt.sort((a, b) => {
        let result = 0;

        if (a.descricao > b.descricao) {
          result = 1;
        } else {
          result = -1;
        }

        return result;
      });
      store.commit("mutAliancaOrgEnt", listarEntOrg);
      console.log('listaOrgEnt', listarEntOrg)
      this.isLoading = false;
    },
    defineDataNascTitular(date) {
      if (date != null) console.log(date);

      console.log(date, this.datanasc);
    },
    calculateAge(date) {
      let currentDate = new Date();
      let birthDate = new Date(date);
      let difference = currentDate - birthDate;
      let age = Math.floor(difference / 31557600000);
      return age;
    },
    habilitaDependentes(incluirDep) {
      if (incluirDep) {
        this.incluirDependente = true;
        this.finalizaprocesso = true;
        this.exibefinaliza = false;

        if (!this.dependentes.length) this.adicionarDependente();
      } else {
        this.finalizaprocesso = true;
        this.exibefinaliza = true;
      }
    },
    adicionarDependente() {
      this.dependentes.push({
        NomeDep: "",
        CPFDep: "",
        GrauParentescoDep: null,
        DataNascDep: "",
        sexo: null,
        nomemae: "",
        estadocivil: null,
        documentoTipodep: null,
        documentoNumerodep: "",
        documentoOrgao: null,
        documentoUf: null,
        documentoDtExpedicao: "",
        certidaonascidovivo: "",
      });
    },
    removerDependente() {
      if (this.dependentes.length > 1) {
        this.dependentes.pop();
      } else {
        this.dependentes = [];

        this.incluirDependente = false;
        this.finalizaprocesso = true;
        this.exibefinaliza = true;
      }
    },
    // onKeydown: function(e) {

    //   if (
    //     // permite somente numeros
    //     (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ||
    //     // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
    //     /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
    //     // permite ctrl+ c,v,x,a,z
    //     /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
    //   ) return;
    //   e.preventDefault();
    //   e.stopPropagation();

    // },
    validaStep1() {
      this.errors = [];

      if (!this.cep || this.cep.length < 9) {
        this.errors.push("Preencha seu cep");
        return false;
      }

      return true;
    },
    validaStep3alt() {
      this.errors = [];

      if (this.selected_orgao == null) {
        this.errors.push("Selecione um orgão público válido");
        return false;
      }

      if (this.selected_profissao == null) {
        this.errors.push("Selecione uma profissão válida");
        return false;
      }

      return true;
    },
    validaStep3() {
      this.errors = [];

      if (this.selected_entidade == null) {
        this.errors.push("Selecione uma entidade de classe válida");
        return false;
      }

      if (this.selected_profissao == null) {
        this.errors.push("Selecione uma profissão válida");
        return false;
      }

      return true;
    },
    validaStep4() {
      this.errors = [];

      if (!this.nome) {
        this.errors.push("Preencha seu nome completo");
        return false;
      }

      if (this.nome.length < 3 || this.nome.indexOf(" ") == 0) {
        this.errors.push("Preencha seu nome completo corretamente");
        return false;
      }

      if (this.datanasc.length > 0 && this.datanasc.length < 10) {
        this.errors.push("Data de nascimento incompleta");
        return false;
      }
      if (!this.datanasc) {
        this.errors.push("Preencha a data de nascimento");
        return false;
      }

      if (this.incluirDependente) {
        let accerros = [0, 0, 0, 0, 0, 0];
        for (let i = 0; i < this.dependentes.length; i++) {
          if (!this.dependentes[i].NomeDep) accerros[0]++;
          // if (!this.dependentes[i].CPFDep) accerros[1]++
          if (!this.dependentes[i].GrauParentescoDep) accerros[2]++;
          if (
            this.dependentes[i].DataNascDep.length > 0 &&
            this.dependentes[i].DataNascDep.length.length < 8
          )
            accerros[3]++;
          if (!this.dependentes[i].DataNascDep) accerros[4]++;
          if (this.tipoorgaoentidade == "orgao") {
            if (!this.dependentes[i].FaixaRemuneracaoDep) accerros[5]++;
          }
        }

        if (accerros[0] > 0) {
          this.errors.push("Preencha o nome de todos os dependentes");
          return false;
        }
        /* if (accerros[1] > 0) {
            this.errors.push('Preencha o CPF de todos os dependentes');
            return false;
          } */
        if (accerros[2] > 0) {
          this.errors.push(
            "Selecione o grau de parentesco de todos dependentes"
          );
          return false;
        }
        if (accerros[3] > 0) {
          this.errors.push(
            "Data de nascimento de algum dos dependentes está incompleta"
          );
          return false;
        }
        if (accerros[4] > 0) {
          this.errors.push(
            "Preencha a data de nascimento de todos dependentes"
          );
          return false;
        }
        if (accerros[5] > 0) {
          this.errors.push(
            "Preencha a faixa de remuneração de todos dependentes"
          );
          return false;
        }

        /*
          if (ddlParentesco.SelectedValue == "13" && idade > DateTime.Parse(proposta.BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('A data de nascimento deve ser menor que a do titular.');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].ESTADO_CIVIL != "C"){
              this.errors.push('O estado civil do titular deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS.FindAll(p => p.GRAU_PARENTESCO == "11").Count > 0){
              this.errors.push('Já existe um beneficiário com o grau parentesco cônjugue .');
          }
          if (ddlParentesco.SelectedValue == "11" && ddlEstadoCivil.SelectedValue.ToUpper() != "C"){
              this.errors.push('O estado civil deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "15" && idade > 18){
              this.errors.push('MENOR SOBRE GUARDA deve ter menos que 18 anos.');
          }
          if ((ddlParentesco.SelectedValue == "20" || ddlParentesco.SelectedValue == "16") && idade < DateTime.Parse(((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter idade maior que a do titular .');
          }
          if (ddlParentesco.SelectedValue == "17" && idade < 18){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter maior de 18 anos .');
          }
          */
      }

      return true;
    },

    validaStep5() {
      this.errors = [];

      if (!this.email) {
        this.errors.push("Preencha o email");
        return false;
      }

      if (!this.emailValid) {
        this.errors.push("Preencha o email corretamente");
        return false;
      }

      if (!this.telefone) {
        this.errors.push("Preencha o telefone");
        return false;
      }
      if (this.telefone.length > 0 && this.telefone.length < 14) {
        this.errors.push("Preencha o telefone corretamente");
        return false;
      }

      return true;
    },
    prevEtapa(anterior) {
      if (anterior == "step-3")
        document.getElementById("step-progress").value = 6.67 * 2;
      if (anterior == "step-4")
        document.getElementById("step-progress").value = 6.67 * 3;
      if (anterior == "step-5")
        document.getElementById("step-progress").value = 6.67 * 4;

      store.commit("mutAliancaProxEtapa", anterior);
    },
    async setEtapa(atual, prox, meta = "") {
      switch (atual) {
        case "step-1":
          if (this.validaStep1()) {
            store.commit("mutAliancaCEP", this.cep);
            await this.getCEPInfo(this.cep);
            store.commit("mutAliancaEstadoID", this.estadoid);
            this.etapa = prox;
          }
          break;
        case "step-2":
          this.isLoading = true;
          if (prox == "step-3-alt") {
            store.commit("mutAliancaFuncPub", "Sim");
            await this.getOrgaos();
          } else {
            store.commit("mutAliancaFuncPub", "Não");
            await this.getEntidadesClasse();
          }
          this.etapa = prox;
          break;
        case "step-3":
          if (meta != "" && meta == "orgao") {
            if (!this.validaStep3alt()) break;
            store.commit("mutAliancaOrgaoPub", this.selected_orgao);
            console.log("Orgão selecionado: ", this.selected_orgao);
          } else {
            if (!this.validaStep3()) break;
            store.commit("mutAliancaEntidadeClasse", this.selected_entidade);
            console.log("Entidade selecionada: ", this.selected_entidade);
          }
          store.commit("mutAliancaProfissao", this.selected_profissao);
          store.commit("mutAliancaFaixaRemuneracao", {
            minimo: this.selected_faixa.split("-")[0],
            maximo: this.selected_faixa.split("-")[1],
          });
          this.etapa = prox;
          document.getElementById("step-progress").value = 6.67 * 3;
          break;
        case "step-4":
          if (this.validaStep4()) {
            store.commit("mutAliancaNome", this.nome);
            store.commit("mutAliancaDataNasc", this.datanasc);
            if (meta != "" && meta == "PD") {
              store.commit("mutAliancaPossuiDep", "Sim");
              store.commit("mutAliancaObjDependentes", this.dependentes);
            } else {
              store.commit("mutAliancaPossuiDep", "Não");
            }
            this.etapa = prox;
            document.getElementById("step-progress").value = 6.67 * 4;

            store.dispatch("disAliancaPlanosFiltros");
            store.dispatch("disAliancaPlanosLista");
          }
          break;
        case "step-5":
          if (this.validaStep5()) {
            store.commit("mutAliancaEmail", this.email);
            store.commit("mutAliancaTelefone", this.telefone);
            store.commit("mutAliancaConsentimentoLGPD", this.consentimentolgpd);
            this.etapa = prox;
            document.getElementById("step-progress").value = 6.67 * 5 + 3;
            document
              .getElementById("step-progress-point2")
              .classList.add("rounded-point-progress-ok");
            this.$router.push("seu-plano");
          }
          break;
      }
    },
    async getOrgaos() {
      this.options_orgaos = [];

      let options_orgaos = await buscarConveniosAPI(this.estadoid);

      options_orgaos = options_orgaos.map((el) => {
        if (el.categorias.some((elTwo) => elTwo === "entidade")) {
          console.log(el.OrgaoNome.replace("&#8211;", "-"));
        }
        return {
          id: el.slug,
          name: el.OrgaoNome.replace("&#8211;", "-"),
          entidade: el.categorias.some(elTwo => elTwo === 'entidade')
        };
      });

      this.options_orgaos = options_orgaos.sort((a, b) => {
        let result = 0;

        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
          result = 1;
        } else {
          result = -1;
        }

        return result;
      });
    },
    async getEntidadesClasse() {
      this.options_entidades = [];
      let options_entidades = await buscarEntidadesAPI(this.estadoid);

      for (let i = 0; i < options_entidades.length; i++) {
        this.options_entidades.push({
          id: options_entidades[i].slug,
          name: options_entidades[i].EntidadeNome.replace("&#8211;", "-"),
        });
      }
    },
    async getOrgaoEntidadeData(group) {
      let tipoentidade = "";

      if (store.getters.getAliancaFuncPub == "Sim") {
        tipoentidade = "orgao";
      } else {
        tipoentidade = "entidade";
      }

      const selectedOrgaoEntidade = await buscarEntidadeOrgaoAPI(group.id);

      this.selected_orgao = group.name;

      store.commit(
        "mutAliancaNumeroContrato",
        selectedOrgaoEntidade.custom_fields.numerocontrato
      );
      store.commit(
        "mutAliancaSubFatura",
        selectedOrgaoEntidade.custom_fields.subfatura
      );

      this.tipoorgaoentidade = tipoentidade;

      if (tipoentidade == "orgao")
        store.commit("mutAliancaOrgaoPub", this.selected_orgao);
      else store.commit("mutAliancaEntidadeClasse", this.selected_entidade);
    },
    async getProfissoes(group) {
      this.isLoading = true;

      this.options_profissoes = [];

      group = group.selectedObject;

      this.selected_entidade = group.name;

      const profissoes = await buscarProfissoesAPIWP(group.id);

      this.options_profissoes = profissoes.map((el) => {
        return {
          id: el.profissao_id,
          name: el.profissao_title,
          slug: el.profissao_slug,
        };
      });

      await this.getOrgaoEntidadeData(group);

      this.options_faixaremuneracao = [];

      // flag criada para saber se um valor já foi escolhido
      this.preenchido = true;

      this.isLoading = false;

      store.dispatch("disAliancaEntidadeInfo");
    },
    async setProfissao(group) {
      this.isLoading = true;

      group = group.selectedObject;
      this.options_faixaremuneracao = [];

      await this.getOrgaoEntidadeData(group);

      this.selected_profissao = group.id || "";

      if (this.tipoorgaoentidade == "orgao") await this.getFaixaRemuneracao();
      else this.setEtapa("step-3", "step-4", this.tipoorgaoentidade);

      store.dispatch("disAliancaEntidadeInfo");

      this.isLoading = false;
    },
    async getFaixaRemuneracao() {
      await store.dispatch("disAliancaGetListaAuxilio");
      this.options_faixaremuneracao =
        store.getters.getAliancaListaFaixaRemuneracao;

      // flag criada para saber se um valor já foi escolhido
      this.preenchidoprofissoes = true;
    },
    getFaixaRemuneracaoDep() {
      this.options_faixaremuneracao =
        store.getters.getAliancaListaFaixaRemuneracao;
    },
    async getEstadoSigla(sigla) {
      let estados_json =
        '{"AC":"Acre","AL":"Alagoas","AP":"Amapá","AM":"Amazonas","BA":"Bahia","CE":"Ceará","DF":"Distrito Federal","ES":"Espírito Santo","GO":"Goiás","MA":"Maranhão","MT":"Mato Grosso","MS":"Mato Grosso do Sul","MG":"Minas Gerais","PR":"Paraná","PB":"Paraíba","PA":"Pará","PE":"Pernambuco","PI":"Piauí","RN":"Rio Grande do Norte","RS":"Rio Grande do Sul","RJ":"Rio de Janeiro","RO":"Rondônia","RR":"Roraima","SC":"Santa Catarina","SE":"Sergipe","SP":"São Paulo","TO":"Tocantins"}';
      let estados = JSON.parse(estados_json);

      this.estadoapi = estados[sigla];
      let slugestado = this.slugify(estados[sigla]);
      this.estadoid = await buscarEstadoIDAPI(slugestado);
    },
    async getCEPInfo(cep) {
      if (cep.length == 9) await this.buscarEndereco(cep.replace("-", ""));
    },

    storageData(key, value) {
      localStorage.setItem(key, value);
    },
    async prepareStep(step) {
      if (step == "step-2") {
        let origemhome = sessionStorage.getItem("AliancaHome");
        if (origemhome != null && origemhome == "homesimulador") {
          let cep = sessionStorage.getItem("AliancaCEP");
          if (cep != null) {
            await this.getCEPInfo(cep);
            store.commit("mutAliancaEstadoID", this.estadoid);
            // store.commit('mutAliancaConsentimentoLGPD', this.consentimentolgpd)
            console.log(cep, this.estadoid);
            this.etapa = "step-2";
            document.getElementById("step-progress").value = 6.67 * 1;
            document
              .getElementById("step-progress-point1")
              .classList.add("rounded-point-progress-ok");
          }
        }
      }

      if (step == "step-3" || step == "step-3-alt") {
        this.isLoading = true;

        if (sessionStorage.getItem("AliancaCEP")) {
          await this.getCEPInfo(sessionStorage.getItem("AliancaCEP"));
          store.commit("mutAliancaEstadoID", this.estadoid);
          await this.getOrgaos();
        }
      }

      if (step == "step-4" || step == "step-5" || step == "end") {
        if (store.getters.getAliancaFuncPub == "Sim") {
          this.selected_orgao = store.getters.getAliancaOrgaoPub;
        } else {
          this.selected_entidade = store.getters.getAliancaEntidadeClasse;
        }
        this.selected_profissao = store.getters.getAliancaProfissao;

        if (step == "end") {
          document.getElementById("step-progress").value = 6.67 * 5 + 3;
          document
            .getElementById("step-progress-point2")
            .classList.add("rounded-point-progress-ok");
          this.$router.push("seu-plano");
        }
      }
    },
    async recoveryStep() {
      console.log(store.getters.getAliancaProxEtapa);
      if (this.resetModeStep == true) store.commit("mutAliancaProxEtapa", null);

      let nextstep = store.getters.getAliancaProxEtapa;
      if (nextstep != null) {
        this.isLoading = true;
        await this.prepareStep(nextstep);
        this.etapa = nextstep;
      } else {
        this.etapa = "step-1";
      }
    },
  },
  async mounted() {
    let localstorage_step = sessionStorage.getItem("AliancaProxEtapa");
    if (localstorage_step != null) {
      store.commit("mutAliancaProxEtapa", localstorage_step);
    }

    // forçando step 4 para carregar os planos
    if (store.getters.getAliancaProxEtapa === "step-5") {
      store.commit("mutAliancaProxEtapa", "step-4");
    }

    this.recoveryStep();

    for (let i = 1; i <= 4; i++) {
      document
        .getElementById("globaletapam" + i)
        .classList.remove("etapas-progresso-mobile-show");
      document
        .getElementById("globaletapaprox" + i)
        .classList.remove("div-proximo-etapa-mobile-show");
    }

    document
      .getElementById("globaletapam1")
      .classList.add("etapas-progresso-mobile-show");
    document
      .getElementById("globaletapaprox1")
      .classList.add("div-proximo-etapa-mobile-show");

    let grauparentesco = await listarGrauParentesco();
    for (let i = 0; i < grauparentesco.length; i++)
      this.options_grauparentesco.push({
        value: grauparentesco[i].BRP_CODIGO,
        text: grauparentesco[i].BRP_DESCRI,
      });
  },
  async created() {
    this.loading = true;
    let retornoQLCE = await integracaoQLCEcommerce();

    if (retornoQLCE != undefined) {
      store.commit("mutAliancaQLCEcommerce", retornoQLCE);
      store.commit("mutAliancaTermos", retornoQLCE.conteudo.login.privacidade);
      store.commit("mutAliancaLogo", retornoQLCE.logo_url.replace("admin.",""));
    }

    this.loading = false;
  },
};
</script>